<!-- <pf-dynamic-control [config]="config"></pf-dynamic-control> -->
@switch (column.type) {
    @case ("string") {
        <pf-input
            #inputElement
            (keydown.shift_tab)="onShiftTab($event)"
            (keydown.Tab)="onTab($event)"
            (keydown.Enter)="onEnter($event)"
            pfStyle="compact"
            [pfReadonly]="!row.editable"
            [control]="control"></pf-input>
    }
    @case ("number") {
        <pf-input
            #inputElement
            (keydown.shift_tab)="onShiftTab($event)"
            (keydown.Tab)="onTab($event)"
            (keydown.Enter)="onEnter($event)"
            inputType="number"
            pfStyle="compact"
            [pfReadonly]="!row.editable"
            [control]="control"></pf-input>
    }
    @case ("date") {
        <pf-date-picker
            #inputElement
            (keydown.shift_tab)="onShiftTab($event)"
            (keydown.Tab)="onTab($event)"
            (keydown.Enter)="onEnter($event)"
            pfStyle="compact"
            [showTime]="false"
            datePickerType="date"
            [pfReadonly]="!row.editable"
            [control]="control"></pf-date-picker>
    }
    @case ("select") {
        <pf-select
            #inputElement
            (keydown.shift_tab)="onShiftTab($event)"
            (keydown.Tab)="onTab($event)"
            (keydown.Enter)="onEnter($event)"
            pfStyle="compact"
            [control]="control"
            [grouped]="column.isEditableDataGrouped"
            [pfReadonly]="!row.editable"
            [data]="column.editableDataSource$ | async | safeArray"></pf-select>
    }
}
